import { render, staticRenderFns } from "./ManagedExpenseColumnHeader.vue?vue&type=template&id=208f0372&scoped=true"
import script from "./ManagedExpenseColumnHeader.vue?vue&type=script&lang=ts"
export * from "./ManagedExpenseColumnHeader.vue?vue&type=script&lang=ts"
import style0 from "./ManagedExpenseColumnHeader.vue?vue&type=style&index=0&id=208f0372&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f0372",
  null
  
)

export default component.exports